const Page = {
  DASHBOARD: 'Dashboard',
  HISTORICAL_CCX_DETAILS: 'Historical CCX Details',
  TEAM: 'Team',
  METRICS: 'Metrics',
  TEAM_PROXY: 'TeamProxy',
};

export default Page;
